/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsPositive } from '../../factoriesAny.js';
export var isPositiveDependencies = {
  typedDependencies,
  createIsPositive
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsPositive.generated.js
// module id = UCKg
// module chunks = 3